import { ITextField } from 'office-ui-fabric-react/lib/TextField';
/**
 * Sets the cursor position to the beginning of a text field
 * @param ref the textfield component props
 */
export default function setCursorPositionToStart(ref: ITextField) {
    if (ref === null) {
        return;
    }
    ref.setSelectionStart(0);
    ref.setSelectionEnd(0);
    ref.focus();
}
